import gql from 'graphql-tag';
import Utils from '../../helpers/utils';

const { secureVariables } = Utils();

export default ({ query, variables }) => {
  query = gql`
    query cmsPage($identifier: String) {
      cmsPage(identifier:$identifier) {
        display_mode
        identifier
        title
        meta_title
        meta_description
        meta_keywords
        content_heading
        subtitle
        short_description
        top_banner_background_image
        cover_image
        cover_background_color
        cover_background_image
        is_include_search
        page_header_render
        rendered_content {
          content
          inline_style
          inline_js
          page_builder_style
          dynamic_blocks {
            banner_id
            content
          }
        }
      }
    }
  `;
  
  secureVariables(variables);

  return { query, variables };
};
